import { $getSelection, $isNodeSelection, $isRangeSelection, type LexicalEditor } from 'lexical';
import LatexNode from '../nodes/LatexNode';

// TODO: This isn't working
export function updateLatexNodeColor(editor: LexicalEditor, newColor: string): boolean {
    let updated = false;

    editor.update(() => {
        const selection = $getSelection();

        if ($isNodeSelection(selection)) {
            const node = selection.getNodes()[0];
            if (node instanceof LatexNode) {
                const newNode = new LatexNode(node.__latex, newColor);
                node.replace(newNode);
                updated = true;
            }
        } else if ($isRangeSelection(selection)) {
            const anchorNode = selection.anchor.getNode();
            const node = anchorNode.getParent();

            if (node instanceof LatexNode) {
                const newNode = new LatexNode(node.__latex, newColor);
                node.replace(newNode);
                updated = true;
            }
        }
    });

    return updated;
}
